import React from "react";
import Button from "react-bootstrap/Button";
import {useGameStore} from "../../features/game/game-store";
import Match from "../../Match";
import {endReasonText, rematchView} from "../../match/endOfGame";
import {formatEloDelta} from "../../match/hud";

export default function EndOfFrame() {
    const mode = useGameStore(s => s.mode);
    const status = useGameStore(s => s.status);
    const players = useGameStore(s => s.players);
    const you = useGameStore(s => s.you);
    const winner = useGameStore(s => s.winner);
    const endReason = useGameStore(s => s.endReason);
    const rematch = useGameStore(s => s.rematch);
    const ruleset = useGameStore(s => s.ruleset);
    const ranked = useGameStore(s => s.ranked);
    const elo = useGameStore(s => s.elo);
    if (status !== "over") return null;

    if (mode === "practice") {
        const p = players[0];
        return <div className="end-of-frame" role="dialog" aria-label="Frame complete">
            <div className="card">
                <h2>{ruleset === "anyball" ? "Table cleared" : "Frame complete"}</h2>
                <p className="big">{p?.score ?? 0} points</p>
                <p>{ruleset === "anyball" ? "Best run" : "Highest break"} {p?.highestBreak ?? 0}</p>
                <div className="actions">
                    <Button onClick={() => Match.startPractice()}>Play again</Button>
                </div>
            </div>
        </div>;
    }

    if (winner == null) {
        return <div className="end-of-frame" role="dialog" aria-label="Frame abandoned">
            <div className="card">
                <h2>No result</h2>
                <p className="reason">Both players left the frame, so it doesn't count for anyone.</p>
                <div className="actions">
                    <Button variant="secondary" onClick={() => Match.backToMenu()}>Back to menu</Button>
                </div>
            </div>
        </div>;
    }

    const won = winner === you;
    const rm = rematchView({players, you, rematch});
    const opponent = rm.opponent;
    const reason = endReasonText(endReason, won, opponent?.name);

    return <div className="end-of-frame" role="dialog" aria-label="Frame over">
        <div className={"card " + (won ? "won" : "lost")}>
            <h2>{won ? "You win!" : "You lose"}</h2>
            {ranked ? <p className="ranked-note">Ranked{ruleset === "anyball" ? " · Any ball" : " · Snooker"}</p> : null}
            <p className="reason">{reason}</p>
            <div className="final-score">
                {players.map((p, i) => <div key={i} className={i === winner ? "winner" : ""}>
                    <span className="n">{p.name}{i === you ? " (you)" : ""}</span>
                    <span className="s">{p.score}</span>
                    <span className="hb">HB {p.highestBreak}</span>
                    {ranked ? <span className={"elo" + (elo ? (elo[i].delta >= 0 ? " up" : " down") : "")} data-elo={elo ? elo[i].rating : undefined}>
                        {elo ? <>Elo {elo[i].rating} <b className="delta">({formatEloDelta(elo[i].delta)})</b></> : "Elo …"}
                    </span> : null}
                </div>)}
            </div>
            {ranked && elo ? <p className="elo-summary" id="elo-summary">
                Your Elo: <b>{elo[you].rating}</b> ({formatEloDelta(elo[you].delta)})
            </p> : null}
            {rm.showTheyAsked ? <p className="rematch-note">{opponent?.name} wants a rematch!</p> : null}
            <div className="actions">
                <Button variant="success" disabled={rm.buttonDisabled} onClick={() => Match.rematch()}>
                    {rm.buttonText}
                </Button>
                <Button variant="secondary" onClick={() => Match.backToMenu()}>Back to menu</Button>
            </div>
            {!opponent?.connected ? <p className="small-note">{opponent?.name} has left.</p> : null}
        </div>
    </div>;
}
